// import React from 'react'

// export const fetchCourseStatus = async ({ BeURL, type, page, limit }) => {
//     try {
//         const res = await fetch(
//             `${BeURL}/course-status?type=${type}&page=${page}&limit=${limit}`,
//             {
//                 method: 'GET',
//                 credentials: "include",
//             }
//         );

//         const data = await res.json();

//         return data;

//     } catch (err) {
//         console.log(err);
//         return null;
//     }
// }





export const fetchCourseStatus = async ({
    BeURL,
    type,
    page = 1,
    limit = 10,
    ...filters
}) => {
    try {

        /* 🔥 BUILD QUERY STRING */
        const params = new URLSearchParams({
            type,
            page,
            limit,
            ...filters
        }).toString();

        const res = await fetch(
            `${BeURL}/course-status?${params}`,
            {
                method: "GET",
                credentials: "include",
            }
        );

        const data = await res.json();

        return data;

    } catch (err) {
        console.log("fetchCourseStatus error:", err);
        return null;
    }
};